import React from "react";

const RecipeCard = ({ recipe, onClick }) => {
  return (
    <div
      onClick={() => onClick(recipe)}
      className="bg-white border border-slate-300 rounded-lg cursor-pointer"
    >
      <img
        className="mb-2 h-36 w-full object-cover rounded-t-lg"
        src={recipe?.image}
        alt={recipe?.name}
      />
      <div className="h-20 md:h-16 px-3 py-0.5">
        <h4 className="font-medium text-black text-sm md:text-base text-ellipsis overflow-hidden">
          {recipe?.title ?? ""}
        </h4>
      </div>
    </div>
  );
};

export default RecipeCard;
